module.exports = __webpack_public_path__ + "static/media/Apple iPhone 6s Silver.f73486ad.png";